import {
  FETCH_PICKUP_TIME,
  UPDATE_PICKUP_TIME,
  FETCH_RESTAURANTS_STATUSSES,
  UPDATE_RESTAURANT_STATUS,
  EDIT_RESTAURANT_SEND_TO_POS_SAGA,
  GET_RESTAUANT_SEND_TO_POS_SAGA,
  FETCH_BUSY_MODES,
  SET_BUSY_MODE,
  DELETE_BUSY_MODE,
  EDIT_RETRY_COUNT,
  FETCH_RETRY_COUNT,
  SET_STORE_AUTO_OPEN,
} from "./types/actionTypes";

export const fetchTime = (resti_id: string) => ({
  type: FETCH_PICKUP_TIME,
  payload: resti_id,
});

export const updatePickupTime = (resti_id: string, time: number) => ({
  type: UPDATE_PICKUP_TIME,
  payload: { resti_id, time },
});

export const fetchRestaurantsStatusses = (
  resti_id: string,
  page: number,
  aggregator: string
) => ({
  type: FETCH_RESTAURANTS_STATUSSES,
  payload: { resti_id, page, aggregator },
});

export const updateRestaurantStatus = (
  data: any,
  page: number,
  aggregator: string
) => ({
  type: UPDATE_RESTAURANT_STATUS,
  payload: { data, page, aggregator },
});

export const editRestaurantSendToPos = (payload: any) => ({
  type: EDIT_RESTAURANT_SEND_TO_POS_SAGA,
  payload,
});

export const getRestaurantsSendToPos = (payload: any) => ({
  type: GET_RESTAUANT_SEND_TO_POS_SAGA,
  payload,
});

export const fetchBusyModes = (resti_id: string) => ({
  type: FETCH_BUSY_MODES,
  payload: { resti_id },
});

export const setBusyMode = (rest_id: string, adjusted_minutes: number) => ({
  type: SET_BUSY_MODE,
  payload: { rest_id, adjusted_minutes },
});

export const deleteBusyMode = (rest_id: string) => ({
  type: DELETE_BUSY_MODE,
  payload: { rest_id },
});

export const editRetryCount = (resti_id: string, count: number) => ({
  type: EDIT_RETRY_COUNT,
  payload: { resti_id, count },
});

export const fetchRetryCount = (resti_id: string) => ({
  type: FETCH_RETRY_COUNT,
  payload: { resti_id },
});

export const setStoreAutoOpen = (rest_id: string, is_open: boolean, delivery_type: string) => ({
  type: SET_STORE_AUTO_OPEN,
  payload: { rest_id, is_open, delivery_type },
});